
    import {
      getAllModules,
      createModule,
      updateModule,
      deleteModule
    } from "@/services/module";

    const state = {
      modules: [],
      processed: false
    };

    const getters = {
      getModules(state) {
        return state.modules;
      },
      moduleProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchModules({ commit }, params) {
          return new Promise((resolve, reject) => {
            getAllModules(
              params
            )
              .then(response => {
                commit("SET_MODULES", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createModule({ commit }, module) {
          return new Promise((resolve, reject) => {
            createModule(module)
              .then(response => {
                commit("CREATED_MODULE");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateModule({ commit }, module) {
          return new Promise((resolve, reject) => {
            updateModule(module)
              .then(response => {
                commit("UPDATED_MODULE");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteModule({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteModule(id)
              .then(response => {
                commit("DELETED_MODULE");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_MODULES(state, data) {
        state.modules = data;
        state.processed = false;
      },
      CREATED_MODULE(state) {
        state.processed = true;
      },
      UPDATED_MODULE(state) {
        state.processed = true;
      },
      DELETED_MODULE(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    